var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7052 18.0003C13.7052 18.4675 14.0869 18.8463 14.5577 18.8463C15.0285 18.8463 15.4102 18.4675 15.4102 18.0003C15.4102 17.5331 15.0285 17.1543 14.5577 17.1543C14.0869 17.1543 13.7052 17.5331 13.7052 18.0003Z",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7052 23.9222C13.7052 24.3894 14.0869 24.7682 14.5577 24.7682C15.0285 24.7682 15.4102 24.3894 15.4102 23.9222C15.4102 23.4549 15.0285 23.0762 14.5577 23.0762C14.0869 23.0762 13.7052 23.4549 13.7052 23.9222Z",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4102 12.0784C15.4102 12.2457 15.3602 12.4093 15.2665 12.5484C15.1728 12.6876 15.0397 12.796 14.8839 12.86C14.7282 12.9241 14.5568 12.9408 14.3914 12.9082C14.226 12.8755 14.0741 12.7949 13.9549 12.6766C13.8357 12.5583 13.7545 12.4076 13.7216 12.2435C13.6887 12.0794 13.7056 11.9093 13.7701 11.7547C13.8347 11.6001 13.9439 11.468 14.0841 11.375C14.2243 11.282 14.3891 11.2324 14.5577 11.2324C14.7838 11.2324 15.0006 11.3216 15.1605 11.4802C15.3203 11.6389 15.4102 11.854 15.4102 12.0784Z",
    fill: "#BC6C42",
    stroke: "#939AA8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20508,
    y: 0.732422,
    width: 26.7049,
    height: 34.535,
    rx: 5.5,
    stroke: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.168a8d3110b56f9c79759b6409ae9c9c.svg";
export { ForwardRef as ReactComponent };